import React from "react";
import { corporateFareTypes } from "../../constants/contants";

interface Flight {
  OnwardFlight?: {
    FCType?: string;
    MAC?: string;
  };
  ReturnFlight?: {
    FCType?: string;
    MAC?: string;
  };
}

interface FareDisplayProps {
  FCType?: string;
  flight?: Flight;
  flightAirCode?: String;
}

const renderFareMessage = (type: string | undefined) => {
  switch (type) {
    case "STUDENT FARE":
      return <span>Student Fare</span>;
    case "SENIOR CITIZEN":
      return <span>Sr. Citizen Fare</span>;
    case "SALE FARE":
      return <span>Sale Fare</span>;
    case "SUPER FARE":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>Super Fare</div>
      );
    default:
      return null;
  }
};

export const renderIndigoFareMessage = (type: string | undefined) => {
  switch (type) {
    case "STUDENT FARE":
      return <span>Student Fare</span>;
    case "SENIOR CITIZEN":
      return <span>Sr. Citizen Fare</span>;
    case "SUPER FARE":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>Super Fare</div>
      );
    case "SAVER":
      return <span>Saver Fare</span>;
    case "SALE FARE":
      return <span>Sale Fare</span>;
    case "FLEXI PLUS FARE":
      return <span>Flexi Plus Fare</span>;
    case "STRETCH":
      return <span>Stretch | Business</span>;
    case "STRETCH+":
      return <span>Stretch+ | Business</span>;
    case "BUSINESS":
      return <span>Business</span>;
    default:
      return null;
  }
};

const FareDisplay: React.FC<FareDisplayProps> = ({
  FCType,
  flight,
  flightAirCode,
}) => {
  const checkFareType = (
    type1: string | undefined,
    type2: string | undefined
  ) =>
    corporateFareTypes.includes(type1 || "") &&
    corporateFareTypes.includes(type2 || "");

  const onwardFCType = flight?.OnwardFlight?.FCType;
  const returnFCType = flight?.ReturnFlight?.FCType;

  const onwardMAC = flight?.OnwardFlight?.MAC;
  const returnMAC = flight?.ReturnFlight?.MAC;

  if (onwardFCType && returnFCType) {
    if (checkFareType(onwardFCType, returnFCType)) {
      return <span>Lower Cancellation</span>;
    }

    if (onwardFCType === "STUDENT FARE" && returnFCType === "STUDENT FARE") {
      return <span>Student Fare</span>;
    }

    if (
      onwardFCType === "SENIOR CITIZEN" &&
      returnFCType === "SENIOR CITIZEN"
    ) {
      return <span>Sr. Citizen Fare</span>;
    }

    if (onwardFCType === "SUPER FARE" && returnFCType === "SUPER FARE") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>Super Fare</div>
      );
    }

    if (
      onwardFCType === returnFCType &&
      onwardMAC === "6E" &&
      returnMAC === "6E"
    ) {
      return <span>{renderIndigoFareMessage(onwardFCType)}</span>;
    }
  }

  // individual `FCType`
  if (corporateFareTypes.includes(FCType || "")) {
    return <span>Lower Cancellation</span>;
  } else if (flightAirCode === "6E") {
    return <span>{renderIndigoFareMessage(FCType)}</span>;
  }

  return renderFareMessage(FCType);
};

export default FareDisplay;
